export const response = {
    data: {
        multiUnitSearch: {
            resultCount: 6,
            listings: [
                {
                    averageRating: 3,
                    bedrooms: 1,
                    bathrooms: {
                        full: 1,
                        half: 0,
                        toiletOnly: 0
                    },
                    petsAllowed: false,
                    instantBookable: false,
                    mobileThumbnailUrl:
                        'https://odis-stage.homeaway.com/odis/listing/0d5163be-5ff2-4fbb-9770-e14653d6ef32.c10.jpg',
                    reviewCount: 3,
                    unitName: 'Economy  Petite',
                    propertyType: 'Hotel',
                    spaces: null,
                    sleeps: 2,
                    detailPageUrl: '/vacation-rental/p4728020?uni_id=5588617',
                    priceSummary: null,
                    propertyMetadata: null,
                    listingId: 1
                },
                {
                    averageRating: 2,
                    bedrooms: 1,
                    bathrooms: {
                        full: 1,
                        half: 0,
                        toiletOnly: 0
                    },
                    petsAllowed: false,
                    instantBookable: false,
                    mobileThumbnailUrl:
                        'https://odis-stage.homeaway.com/odis/listing/0d5163be-5ff2-4fbb-9770-e14653d6ef32.c10.jpg',
                    reviewCount: 2,
                    unitName: 'Economy Petite, 2 Queen Bed',
                    propertyType: 'Hotel',
                    spaces: null,
                    sleeps: 2,
                    detailPageUrl: '/vacation-rental/p4728020?uni_id=5588621',
                    priceSummary: {
                        pricePeriodDescription: 'per night',
                        formattedAmount: '$225',
                        edapEventJson:
                            "{'unituuid':'150310','eventstartdate':'2019-07-17','eventenddate':'2019-07-21','eventnumadults':'1','eventnumchildren':'0','eventcurrency':'USD','eventpets':'false','stramount':'$225','perioddescription':'[object Promise]'}"
                    },
                    propertyMetadata: null,
                    listingId: 2
                },
                {
                    averageRating: 1,
                    bedrooms: 1,
                    bathrooms: {
                        full: 1,
                        half: 0,
                        toiletOnly: 0
                    },
                    petsAllowed: false,
                    instantBookable: false,
                    mobileThumbnailUrl:
                        'https://odis-stage.homeaway.com/odis/listing/0d5163be-5ff2-4fbb-9770-e14653d6ef32.c10.jpg',
                    reviewCount: 1,
                    unitName: 'Deluxe Room,1 Queen Bed',
                    propertyType: 'Hotel',
                    spaces: null,
                    sleeps: 2,
                    detailPageUrl: '/vacation-rental/p4728020?uni_id=5588626',
                    priceSummary: null,
                    propertyMetadata: null,
                    listingId: 3
                },
                {
                    averageRating: 1,
                    bedrooms: 1,
                    bathrooms: {
                        full: 1,
                        half: 0,
                        toiletOnly: 0
                    },
                    petsAllowed: false,
                    instantBookable: false,
                    mobileThumbnailUrl:
                        'https://odis-stage.homeaway.com/odis/listing/0d5163be-5ff2-4fbb-9770-e14653d6ef32.c10.jpg',
                    reviewCount: 1,
                    unitName: 'Deluxe Room, 1 King Bed',
                    propertyType: 'Hotel',
                    spaces: null,
                    sleeps: 2,
                    detailPageUrl: '/vacation-rental/p4728020?uni_id=5588629',
                    priceSummary: null,
                    propertyMetadata: null,
                    listingId: 4
                },
                {
                    averageRating: null,
                    bedrooms: 1,
                    bathrooms: {
                        full: 1,
                        half: 0,
                        toiletOnly: 0
                    },
                    petsAllowed: false,
                    instantBookable: false,
                    mobileThumbnailUrl:
                        'https://odis-stage.homeaway.com/odis/listing/0d5163be-5ff2-4fbb-9770-e14653d6ef32.c10.jpg',
                    reviewCount: null,
                    unitName: 'Premium Room, 1 King Bed',
                    propertyType: 'Hotel',
                    spaces: null,
                    sleeps: 2,
                    detailPageUrl: '/vacation-rental/p4728020?uni_id=5588636',
                    priceSummary: null,
                    propertyMetadata: null,
                    listingId: 5
                },
                {
                    averageRating: null,
                    bedrooms: 1,
                    bathrooms: {
                        full: 1,
                        half: 0,
                        toiletOnly: 0
                    },
                    petsAllowed: false,
                    instantBookable: false,
                    mobileThumbnailUrl:
                        'https://odis-stage.homeaway.com/odis/listing/0d5163be-5ff2-4fbb-9770-e14653d6ef32.c10.jpg',
                    reviewCount: null,
                    unitName: 'Deluxe Room, 2 Double Beds',
                    propertyType: 'Hotel',
                    spaces: null,
                    sleeps: 2,
                    detailPageUrl: '/vacation-rental/p4728020?uni_id=5588632',
                    priceSummary: null,
                    propertyMetadata: null,
                    listingId: 6
                }
            ],
            __typename: 'SearchResult'
        }
    }
};
